import React from "react";
import Desplegable from "../../desplegable";
import VistaIdiomas from "../vistas/vista_idiomas";
import FormIdiomas from "../formularios/form_idiomas";

const DesplegableTipoFormacion = (props) => {
    return (
        <Desplegable
            eventKey="5"
            id="5"
            handleButtonShow={props.handleButtonShow}
            showModal={props.state.showModalMatrix[5]}
            boton="Añadir"
            Toogle={"Idiomas"}
            Text={
                <VistaIdiomas
                    DatosUsuario={props.state.DatosUsuario}
                    showModalIdiomasArray={props.state.showModalMatrix[6]}
                    handleButtonShow={props.handleButtonShow}
                    setIdioma={props.setIdioma}
                    putIdioma={props.putIdioma}
                    deleteIdioma={props.deleteIdioma}
                    setAlert={props.setAlert}
                    ErrorHandling={props.ErrorHandling}
                />
            }
            Form={
                <FormIdiomas
                    DatosUsuario={props.state.DatosUsuario}
                    handleButtonShow={props.handleButtonShow}
                    setIdioma={props.setIdioma}
                    putIdiomas={props.putIdiomas}
                    setAlert={props.setAlert}
                    ErrorHandling={props.ErrorHandling}
                />
            }
            canEdit={true}
        />
    );
}

export default DesplegableTipoFormacion;